// extracted by mini-css-extract-plugin
module.exports = {"contact":"ContactInfo_contact__GTcSU","email":"ContactInfo_email__38eAp"};